import { createStore, reconcile } from "solid-js/store";

import {
  GetFaceAuthCfgByCPFForForgetPwd,
  GetFaceAuthCfgByLogin,
} from "@/api/clientApi/user.ts";
import {
  GetFaceIndexRes,
  GetUserAuthV2,
  GetUserKycStatus,
  ReportUserAuthData,
  RequestFaceIndexPopInfoFace,
  RequestKycPopInfo,
} from "@/api/clientApi/userKyc.ts";
import { DialogType } from "@/components/Dialogs/types.ts";
import { useDialog } from "@/components/Dialogs/useDialog.ts";
import { VerifyTypePopInfoEnum } from "@/enum/loginRegister";
import { useSettings } from "@/hooks/profile/useSettings.ts";
import { getLocale } from "@/i18n";
import { isMobile } from "@/lib/isMobile.ts";
import { sdkManager } from "@/lib/sdk/sdkManager";
import { formatCpfAndCnpj, toOutLink, urlAddParam } from "@/lib/utils.ts";
import { userStore } from "@/stores/userStore.ts";
import {
  IdentifyType,
  KYCVerifyStatusResult,
  KycProvider,
  UserIdentifyCheckType,
  UserKycAuthActionType,
} from "@/types/compontent/base/baseEnum.ts";
import {
  GetFaceAuthCfgByCPFForForgetPwdReq,
  GetFaceAuthCfgByCPFForForgetPwdResp,
} from "@/types/swagger/loginV2.ts";
import { RequestFaceIndexPopInfoRsp } from "@/types/swagger/responsible.ts";
import {
  GetUserAuthV2Rsp,
  GetUserKycStatusRsp,
  RequestKycPopInfoRsp,
} from "@/types/swagger/userIDRisk.ts";
import { GetFaceAuthCfgByLoginReq } from "@/types/swaggerex/activity";
import { GetFaceIndexResRsp } from "@/types/swaggerex/userIDRisk.ts";

import { deviceInfo } from "./deviceStore";

const { showDialog } = useDialog();

let kyc4sdkInstance = null;

const initialStore = {
  userAuth: {} as GetUserAuthV2Rsp,
  kycConfig: {},
  kycInfo: {} as GetUserKycStatusRsp | GetFaceIndexResRsp,
  tokenConfig: {} as
    | RequestKycPopInfoRsp
    | RequestFaceIndexPopInfoRsp
    | GetFaceAuthCfgByCPFForForgetPwdResp,
  // faceIndexCallback: () => ({}) as unknown,
};

export const [kYCState, setKYCState] = createStore(initialStore);

// 获取当前操作KYC是否通过
const getUserKycAuthByAction = async (
  actionType = UserKycAuthActionType.login,
  callback?: () => Promise<
    unknown & { user_auth?: { need_face_index?: boolean } }
  >,
) => {
  // setKYCState("faceIndexCallback", callback); // 怎么存就是存不进去
  window.faceIndexCallback = callback;

  let accessIntercept = true;

  const res = await GetUserAuthV2({
    action_type: actionType,
  });
  if (res) {
    if (res.identify_type == IdentifyType.cpf && res.identify) {
      res.identify = formatCpfAndCnpj(res.identify || "", 1);
    }
    if (
      res.kyc_identify &&
      res.kyc_identify.identify_type == IdentifyType.cpf &&
      res.kyc_identify.identify
    ) {
      res.kyc_identify.identify = formatCpfAndCnpj(
        res.kyc_identify.identify || "",
        1,
      );
    }
    accessIntercept =
      (!!res.need_check && res.need_check !== UserIdentifyCheckType.no) ||
      (!!res.need_kyc && res.need_kyc > 0);
    // 老的userAuth
    setKYCState("userAuth", reconcile({ ...res }));
    // 老的kycConfig
    setKYCState(
      "kycConfig",
      reconcile({
        kyc_provider: res.kyc_provider,
        action:
          res.action_type == UserKycAuthActionType.login || res.action_type == 0
            ? 0
            : 1,
        action_type: res.action_type,
      }),
    );
    if (
      [UserKycAuthActionType.login, UserKycAuthActionType.bet].includes(
        KYCStore.userAuth?.action_type,
      ) ||
      KYCStore.userAuth?.web_pop
    ) {
      toVerifyStart(actionType);
    } else if (
      [
        UserKycAuthActionType.exclusion,
        UserKycAuthActionType.deposit,
        UserKycAuthActionType.withdraw,
        UserKycAuthActionType.noActivity,
        UserKycAuthActionType.resetpwd,
        UserKycAuthActionType.changData,
        UserKycAuthActionType.changeBindEmail,
        UserKycAuthActionType.personalCenter,
      ].includes(KYCStore.userAuth?.action_type)
    ) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const functionCallback = async (): Promise<any> => {
        if (callback) {
          // 前置 call 确认是否需要 面部辨识, 如果要 user_auth 会有值
          const _res = await callback?.();

          if (!_res?.user_auth) return;
          // 老的userAuth
          setKYCState(
            "userAuth",
            reconcile({ ...KYCStore?.userAuth, ..._res?.user_auth }),
          );
          // 老的kycConfig
          setKYCState(
            "kycConfig",
            reconcile({
              ...KYCStore.kycConfig,
              kyc_provider: _res?.user_auth?.kyc_provider,
              action:
                _res?.user_auth?.action_type == UserKycAuthActionType.login ||
                _res?.user_auth?.action_type == 0
                  ? 0
                  : 1,
              action_type: _res?.user_auth?.action_type,
            }),
          );
          toVerifyStart(actionType, _res?.user_auth?.need_face_index, callback);
        } else {
          toVerifyStart(actionType);
        }
      };
      // if (
      //   [
      //   ].includes(KYCStore.userAuth?.action_type)
      // ) {
      //   if (!accessIntercept) return !accessIntercept;
      //   // 弹窗询问
      //   showDialog({
      //     type: DialogType.Tips,
      //     data: {
      //       title: t("common.tips"),
      //       content: t("kyc.verify_prompt"),
      //       // cancelText: "Cancel",
      //       confirmText: t("common.confirm"),
      //       onConfirm: () => {
      //         functionCallback();
      //       },
      //       onCancel: () => {},
      //     },
      //   });
      //   return !accessIntercept;
      // } else functionCallback();
      // await functionCallback();
      // return !accessIntercept;
      // 只有提交有callback, 路由点击等拦截的时候没有callback
      if (callback) return functionCallback();
      else {
        functionCallback();
        return !accessIntercept;
      }
    }
    return !accessIntercept;
  } else return !accessIntercept;
};

const getJumpOutResult = () => {
  if (deviceInfo.appShell !== "Browser") {
    if (deviceInfo.android) {
      // useDialogStore().open({
      //   title: useNuxtApp().$t("TIP201"),
      //   text: useNuxtApp().$t("N0877", { host: useAppName().value }),
      //   ok: () => {
      //     const url = Helper.urlAddParam(
      //       window.location.href,
      //       "cToken=" + vueStorage(StorageKey.Token, "").value,
      //     );
      //     window.location.href = `intent://${url.replace(/^https?:\/\//, "")}#Intent;scheme=https;package=com.android.chrome;end;`;
      //   },
      //   ok_text: useNuxtApp().$t("N0878"),
      //   cancel_text: false,
      //   show_close: false,
      //   click_out_close: false,
      // });
    } else {
      // useDialogStore().open({
      //   title: useNuxtApp().$t("TIP201"),
      //   text: useNuxtApp().$t("N0877", { host: useAppName().value }),
      //   ok: () => {},
      //   ok_text: useNuxtApp().$t("N0878"),
      //   cancel_text: false,
      //   show_close: false,
      //   click_out_close: false,
      // });
    }
    return true;
  }
  return false;
};

// 只在getUserKycAuthByAction方法执行
const toVerifyStart = (
  actionType: UserKycAuthActionType,
  isNeedFaceIndex?: boolean,
  callback?: () => void,
) => {
  const { getUserInfo } = useSettings();
  // 这里可以设置是否再次自动打开
  if (
    !!KYCStore.userAuth?.need_check &&
    KYCStore.userAuth?.need_check !== UserIdentifyCheckType.no
  ) {
    showDialog({
      type: DialogType.KYC,
      data: {
        closeCallback: () => {
          getUserInfo();
        },
      },
    });
  } else {
    if (!!KYCStore.userAuth?.need_kyc && KYCStore.userAuth?.need_kyc > 0) {
      // 需要验证kyc
      if (KYCStore.userAuth?.need_kyc > 0 || KYCStore.userAuth?.need_identify) {
        showDialog({
          type: DialogType.KYC,
          data: {
            closeCallback: () => {
              getUserInfo();
            },
          },
        });
        // } else  {
        //   // UserIdentifyCheckType
        //   // if (inAPP) {}
        //   if (KYCStore.userAuth.kyc_status || !KYCStore.userAuth.need_identify) {
        //     if (KYCStore.userAuth.kyc_status === KYCVerifyStatusResult.success) {
        //       console.log(KYCStore.userAuth);
        //     }
        //   }
        //   // 打开KYC验证首页
        //   showDialog({
        //     type: DialogType.KYC,
        //   });
      } else if (KYCStore.userAuth?.need_face_index || isNeedFaceIndex) {
        const toOutLink = getJumpOutResult();
        if (toOutLink) return;

        showDialog({
          type: DialogType.FacialRecognition,
          data: {
            checkIdentityCallback: () => {
              toVerifyKyc(
                actionType,
                undefined,
                undefined,
                KYCStore.userAuth?.need_face_index || isNeedFaceIndex,
              );
            },
            //面部辨识后需要执行回调
            callback: callback,
          },
        });
      } else if (KYCStore.userAuth?.need_faceauth) {
        switch (KYCStore.userAuth?.kyc_provider) {
          case KycProvider.serasaexperian:
            break;
          case KycProvider.legitimuz:
            break;
          case KycProvider.sumSub:
            // useKycStore().getKycAction(KycActionType.withdraw)
            break;
          case KycProvider.veriff:
            break;
        }
      }
    } else if (
      KYCStore.userAuth?.kyc_status === KYCVerifyStatusResult.success
    ) {
      // kyc 成功
      if (KYCStore.userAuth?.need_face_index || isNeedFaceIndex) {
        const toOutLink = getJumpOutResult();
        if (toOutLink) return;

        showDialog({
          type: DialogType.FacialRecognition,
          data: {
            checkIdentityCallback: () => {
              toVerifyKyc(
                actionType,
                undefined,
                undefined,
                KYCStore.userAuth?.need_face_index || isNeedFaceIndex,
              );
            },
            //面部辨识后需要执行回调
            callback: callback,
          },
        });
      }
    }
  }
};

// 只在kycStore里执行
/* eslint-disable @typescript-eslint/no-explicit-any */
const getNewAccessTokenReal = async (
  actionType: UserKycAuthActionType,
  count: number = 0,
  params?: {
    cpf?: string;
    email?: string;
    phone?: string;
    a_code?: string;
  },
  isNeedFaceIndex?: boolean,
): Promise<any> => {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  const requestParams: any = {
    ...KYCStore.kycConfig,
  };
  const token = userStore?.token || "";
  // webview包?  useDeviceConfig().value.webview
  // 0/1
  const isJump = KYCStore.userAuth?.jump && isMobile();
  if (isJump) {
    requestParams.return_url = window.location.href;
  }
  if (!isMobile()) {
    requestParams.return_url = urlAddParam(
      window.location.href,
      "cToken=" + token,
    );
  }
  if (requestParams.return_url) {
    requestParams.return_url = urlAddParam(
      requestParams.return_url,
      "from=kyc",
    );
  }

  let res = null;
  if (isNeedFaceIndex) {
    const _params = {
      kyc_provider: requestParams?.kyc_provider,
      action_type: actionType,
      verify_type: VerifyTypePopInfoEnum.face,
      return_url: requestParams?.return_url,
    };
    res = await RequestFaceIndexPopInfoFace(_params);
  } else if (actionType === UserKycAuthActionType.cpfResetPwd) {
    res = await GetFaceAuthCfgByCPFForForgetPwd(
      params as GetFaceAuthCfgByCPFForForgetPwdReq,
    );
  } else if (actionType === UserKycAuthActionType.loginByFaceIndex) {
    res = await GetFaceAuthCfgByLogin(params as GetFaceAuthCfgByLoginReq);
  } else {
    res = await RequestKycPopInfo(requestParams);
  }

  if (res) {
    // tokenConfig.pop_url iframeUrl
    setKYCState("tokenConfig", reconcile({ ...res }));
    setKYCState("kycConfig", (prev) => ({
      ...prev,
      external_action_id: res?.external_action_id,
    }));
    if (res.retry) {
      count++;
      if (count > 2) {
        return;
      }
      setTimeout(() => {
        getNewAccessTokenReal(actionType, count);
      }, 1000);
    }
    return res;
  }
};

// 未登录时，CPF重置密码也会走这个方法
const toVerifyKyc = async (
  actionType: UserKycAuthActionType,
  params?: {
    cpf?: string;
    email?: string;
    phone?: string;
    a_code?: string;
  },
  callback?: (final?: boolean) => void,
  isNeedFaceIndex?: boolean,
) => {
  // const isJump = (isWebView() || this.userAuth.jump) && isMobile()
  let isJump = KYCStore.userAuth?.jump && isMobile();
  let kyc_provider = KYCStore.userAuth?.kyc_provider;
  if (KYCStore.userAuth?.jump && !KYCStore.userAuth?.mode) {
    // if (!isWebView()) {
    //   winObj = window.open('', '_blank')
    //   if (winObj) {
    //     closeWin = window.setTimeout(() => {
    //       winObj.close()
    //     }, 10000)
    //   }
    // }
  }
  if (!KYCStore.tokenConfig?.ready) {
    await getNewAccessTokenReal(actionType, 0, params, isNeedFaceIndex);
  }
  if (KYCStore.userAuth?.mode && kyc_provider == KycProvider.legitimuz) {
    kyc4LaunchWebSdk(actionType);
    callback?.();
    return;
  }
  // 如果是cpf重置密码
  if (
    actionType === UserKycAuthActionType.cpfResetPwd ||
    actionType === UserKycAuthActionType.loginByFaceIndex
  ) {
    kyc_provider = KYCStore.tokenConfig?.kyc_provider;
    isJump = KYCStore.tokenConfig?.jump && isMobile();
  }
  switch (kyc_provider) {
    case KycProvider.serasaexperian:
    case KycProvider.myid:
    case KycProvider.veriff:
    case KycProvider.legitimuz:
      if (isJump) {
        // if (isWebView()) {}
        // callback?.();
        if (KYCStore.tokenConfig?.pop_url) {
          callback?.(true);
          toOutLink(KYCStore.tokenConfig?.pop_url);
        }
      } else {
        // if (kyc_provider == KycProvider.legitimuz) {
        //   // 打开iframe dialog
        //   callback?.();
        // }
        callback?.();
      }
      break;
    case KycProvider.sumSub:
      break;
  }
};

const kyc4LaunchWebSdk = async (
  actionType: UserKycAuthActionType,
  tokenConfig?: RequestKycPopInfoRsp,
) => {
  if (!tokenConfig) {
    tokenConfig = await getNewAccessTokenReal(actionType, 0);
  }
  const { identify, token } = tokenConfig;
  // document.getElementById('legitimuz-action-verify')?.click()
  import("https://cdn.legitimuz.com/js/sdk/legitimuz-sdk.js").then(
    /* eslint-disable @typescript-eslint/no-explicit-any */
    (res: any) => {
      kyc4sdkInstance = Legitimuz({
        host: "https://api.legitimuz.com",
        token: token,
        lang: getLocale() || "en",
        onSuccess: (eventName: string) => {
          kyc4VerifyEnd();
        },
        onError: (eventName: string) => {
          // console.log('==============================>', eventName)
        },
      });
      kyc4sdkInstance.mount();
      kyc4sdkInstance.verifyDocument({ cpf: identify });
    },
  );
};

const kyc4VerifyEnd = () => {
  ReportUserAuthData();
};

// 个人kyc状态
const getKycStatus = async () => {
  const res = await GetUserKycStatus();
  if (res) {
    if (res.kyc_status === KYCVerifyStatusResult.success) {
      sdkManager.tdReportEvent("kyc_verification_success", {});
    } else if (res.kyc_status === KYCVerifyStatusResult.fail) {
      sdkManager.tdReportEvent("kyc_verification_fail", {});
    }
    setKYCState("kycInfo", reconcile({ ...res }));
  }
};

// cpf找回密码，个人kyc状态
const getKycStatusCpfResetPwd = async () => {
  const res = await GetFaceIndexRes({
    action_id: KYCStore.tokenConfig?.action_id,
  });
  if (res) {
    setKYCState("kycInfo", reconcile({ ...res }));
  }
};

const clearKYCStore = () => {
  setKYCState("kycConfig", reconcile({}));
  setKYCState("kycInfo", reconcile({} as GetUserKycStatusRsp));
  setKYCState("tokenConfig", reconcile({} as RequestKycPopInfoRsp));
};

export const KYCStore = {
  userAuth: kYCState.userAuth,
  kycConfig: kYCState.kycConfig,
  kycInfo: kYCState.kycInfo,
  tokenConfig: kYCState.tokenConfig,
  // faceIndexCallback: kYCState.faceIndexCallback,
  getUserKycAuthByAction,
  toVerifyStart,
  getNewAccessTokenReal,
  toVerifyKyc,
  kyc4LaunchWebSdk,
  getKycStatus,
  clearKYCStore,
  getKycStatusCpfResetPwd,
};
